import React from 'react';
import { Field } from 'formik';

const HoneyPot = () => (
    <div
        style={{
            height: 0,
            width: 0,
            visibility: 'hidden',
        }}
    >
        <label
            aria-hidden="true"
            style={{ backgroundColor: '#FFF', color: '#000' }}
        >
            Do not enter a value. This is for spam protection.
            <Field
                autoComplete="off"
                name="email"
                aria-label="Email"
                tabIndex={-1}
            />
        </label>
    </div>
);

HoneyPot.ALTERNATIVE_NAME = 'dfnBBEShRQumairGI5QMCu4XId81BN6R';

HoneyPot.execute = (fn) => (formik, actions) => {
    if (formik.email) {
        alert(
            'HONEYPOT Failed: If this is a legitimate form submission, please disable auto-complete before re-filling out the form.',
        );

        return;
    }

    formik.email = formik[HoneyPot.ALTERNATIVE_NAME];
    delete formik[HoneyPot.ALTERNATIVE_NAME];
    return fn(formik, actions);
};

export default HoneyPot;
